const youtubeInfo = "AIzaSyC5swBB0pqcMuAHnkE9ENcLbGAEPkg6Dm4";

export { youtubeInfo };
